import templateUrl from './display-square-pic.html';

export const displaySquarePicComponent = {
    bindings: {
        coverPicUrl: '@'
    },
    templateUrl,
    controller: class DisplaySquarePicComponent {
        $onChanges(changes) {
            if(changes.coverPicUrl && !changes.coverPicUrl.isFirstChange()) {
                this.coverPicUrl = changes.coverPicUrl.currentValue;
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/display-square-pic/display-square-pic.component.js